import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'webform-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.scss'],
})
export class InfoboxComponent {
  @Input() title!: string;
  @Input() text!: string;
  @Input() image: string = '';
  @Input() link: string = '';
}
